// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bV0en","colMin":"styles_colMin__3GCQ7"};